/* Vynix swatch painter — single tones + diagonal two-tone swatches. Edit here for swatch logic. */
(function(){
  var HL=function(a,p){return 'radial-gradient(circle at 38% 30%, rgba(255,255,255,'+a+'), rgba(255,255,255,0) '+p+'%)';};
  var GRAD={
    gold:    HL('.5','55')+', linear-gradient(135deg,#a87f1e 0%,#e8c662 30%,#f8ecb4 46%,#d2a843 62%,#936b14 100%)',
    rose:    HL('.5','55')+', linear-gradient(135deg,#9e5f50 0%,#e0a08b 30%,#f6d6c9 46%,#cc8870 62%,#955647 100%)',
    white:   HL('.42','55')+', linear-gradient(135deg,#a9aab0 0%,#e9e9ee 30%,#fdfdfe 46%,#cfcfd6 62%,#9c9da4 100%)',
    silver:  HL('.55','55')+', linear-gradient(135deg,#7f858f 0%,#dde3ea 30%,#fbfeff 46%,#bdc4cf 62%,#767d88 100%)',
    pearl:   HL('.55','70')+', linear-gradient(135deg,#d9cbb8 0%,#f3ece0 30%,#fffdf9 46%,#e6dccd 62%,#cdbda8 100%)',
    emerald: HL('.7','42')+', linear-gradient(135deg,#0b5538 0%,#1c8456 30%,#37a673 46%,#136045 62%,#093f2a 100%)',
    onyx:    HL('.5','40')+', linear-gradient(135deg,#141519 0%,#34373d 30%,#4d5159 46%,#202227 62%,#0e0f12 100%)'
  };
  var TONE={
    gold:['#f8ecb4','#e8c662','#a87f1e'],
    rose:['#f6d6c9','#e0a08b','#9e5f50'],
    white:['#fdfdfe','#e9e9ee','#a9aab0'],
    silver:['#fbfeff','#dde3ea','#7f858f'],
    pearl:['#fffdf9','#f3ece0','#d9cbb8'],
    emerald:['#5fc28f','#1c8456','#0b5538'],
    onyx:['#4d5159','#2a2d33','#111317'],
    diamond:['#ffffff','#eaf0f5','#c4ccd6'],
    navy:['#3a5a93','#1f3a6b','#11254a'],
    brightblue:['#5aa6ef','#2f7fd6','#1857a3'],
    amethyst:['#b07fd0','#8a4fb5','#5e2f86'],
    ruby:['#e0566a','#c0293f','#8c1326']
  };
  var MAP=[['rose gold','rose'],['white gold','white'],['sterling silver','silver'],['diamond white','diamond'],['emerald green','emerald'],['onyx black','onyx'],['navy blue','navy'],['bright blue','brightblue'],['ruby red','ruby'],['two-tone','__two__'],['two tone','__two__'],['amethyst','amethyst'],['emerald','emerald'],['platinum','silver'],['pearl','pearl'],['silver','silver'],['onyx','onyx'],['navy','navy'],['ruby','ruby'],['rose','rose'],['diamond','diamond'],['gold','gold'],['white','white'],['black','onyx']];
  function detect(name){
    if(!name) return [];
    var s=name.toLowerCase(), found=[];
    for(var i=0;i<MAP.length;i++){
      var ph=MAP[i][0], c=MAP[i][1], idx=s.indexOf(ph);
      if(idx>-1){
        if(c==='__two__'){ found.push({c:'gold',i:idx}); found.push({c:'silver',i:idx+0.5}); }
        else { found.push({c:c,i:idx}); }
        s=s.substring(0,idx)+new Array(ph.length+1).join(' ')+s.substring(idx+ph.length);
      }
    }
    found.sort(function(a,b){return a.i-b.i;});
    var out=[], seen={};
    for(var j=0;j<found.length;j++){ if(!seen[found[j].c]){ seen[found[j].c]=1; out.push(found[j].c); } }
    return out;
  }
  function single(c){
    if(GRAD[c]) return GRAD[c];
    var t=TONE[c]; if(!t) return null;
    return HL('.5','55')+', linear-gradient(135deg,'+t[2]+' 0%,'+t[1]+' 32%,'+t[0]+' 50%,'+t[1]+' 68%,'+t[2]+' 100%)';
  }
  function dbl(a,b){
    var A=TONE[a], B=TONE[b]; if(!A||!B) return null;
    return HL('.4','50')+', linear-gradient(135deg,'+A[0]+' 0%,'+A[1]+' 26%,'+A[2]+' 49.5%,'+B[0]+' 50.5%,'+B[1]+' 74%,'+B[2]+' 100%)';
  }
  function bg(name){
    var cs=detect(name);
    if(cs.length===0) return null;
    if(cs.length===1) return single(cs[0]);
    return dbl(cs[0],cs[1]);
  }
  function valueOf(el){ var sr=el.querySelector('.sr-only'); if(sr&&sr.textContent.trim()) return sr.textContent.trim(); return el.getAttribute('aria-label')||el.getAttribute('style')||''; }
  function paint(){
    document.querySelectorAll('label.color-swatch').forEach(function(el){
      var name=valueOf(el);
      if(el.getAttribute('data-vynix')===name) return;
      var g=bg(name); if(!g) return;
      el.style.setProperty('--swatch-background',g,'important');
      el.style.setProperty('background',g,'important');
      el.style.setProperty('background-color','transparent','important');
      el.setAttribute('data-vynix',name);
    });
  }
  function run(){ paint(); new MutationObserver(paint).observe(document.body,{childList:true,subtree:true}); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();
